/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/explore/explore-collection',['require','marionette','core/templates','modules/components/text-panel'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var Marionette = require('marionette');
  var templates = require('core/templates');
  var TextPanel = require('modules/components/text-panel');

  /*****************************************************************************************************************///}

  var ExploreCollection = Marionette.CollectionView.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    className: 'explore-content',

    childView: TextPanel,

    childViewOptions: {
      template: templates['screens/explore/explore-content'],
      attributes: function() {
        return {
          'data-index': this.model.collection.indexOf(this.model)
        };
      }
    },

    activeIndex: -1,

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    addChild: function(child, ChildView, index)
    {
      // if persistentNodes is true, render all clicked items, else just show selected
      if ((this.options.persistentNodes && child.get('complete')) || child === this.collection.at(this.activeIndex))
      {
        Marionette.CollectionView.prototype.addChild.apply(this, arguments);
      }
    }

  /*****************************************************************************************************************///}

  });

  return ExploreCollection;

});

